import { gql } from '@apollo/client';

export const GET_COLLECTION_ITEMS_BY_PROPERTY = gql`
  query allCollectionItems($limit: Int, $next: String, $filterProperties: [FilterPropertyInput!]) {
    collectionItems(limit: $limit, next: $next, filterProperties: $filterProperties) {
      results {
        id
        name
        slug
      }
      hasNext
      hasPrevious
      resultsNumber
    }
  }
`;

export default GET_COLLECTION_ITEMS_BY_PROPERTY;
